import styled from 'styled-components'

export const QualityTransparency = styled.div`
  margin-bottom: 24px;
`

export const DownloadButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;

  & > button {
    margin: 0;
  }
`
